import useDashboardSubject from '../../../Hooks/useDashboardSubject';
import { coachRoutes } from './coachRoutes';

// Cards call this themselves (instead of taking a prop) so none can fall back to the Coach-only
// paths while rendered inside an Admin visit.
const useCoachRoutes = () => {
    const subject = useDashboardSubject('coach');
    return coachRoutes({ coachId: subject.id, isVisit: subject.isVisit });
};

export default useCoachRoutes;
